// src/context/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext({
  currentUser: null,
  loading: true,
  error: null,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        setCurrentUser(user);
        setLoading(false);

        if (user) {
          // Check localStorage for userProfile
          const storedProfile = localStorage.getItem("userProfile");
          if (storedProfile) {
            try {
              const parsedProfile = JSON.parse(storedProfile);

              // If uid is missing, add it from the authenticated user
              if (!parsedProfile.uid) {
                parsedProfile.uid = user.uid;
                localStorage.setItem(
                  "userProfile",
                  JSON.stringify(parsedProfile)
                );
              }
            } catch (error) {
              console.error(
                "Error parsing userProfile from localStorage:",
                error
              );
            }
          }
        }
      },
      (err) => {
        console.error("Auth state change error:", err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const contextValue = {
    currentUser,
    loading,
    error,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};